import { createFeatureSelector, createReducer, on } from '@ngrx/store';
import { UserPreferenceActions } from '../actions/user-preference.actions';
import { UserPreferenceResultType } from '@shared/types/user-preference.types';
import { UserPreferenceEnum } from '@shared/enums/common-data/user-preference.enum';
import { UserPreferenceConfig } from '@shared/models/shared/user-preference.model';

const userPreferenceFeatureKey = 'userPreference';
const userPreferenceFeatureSelector = createFeatureSelector<UserPreferenceState>(userPreferenceFeatureKey);

export interface UserPreferenceState {
  [UserPreferenceEnum.inbondLayout]: UserPreferenceResultType | undefined;
  [UserPreferenceEnum.redeliveryLayout]: UserPreferenceResultType | undefined;
}

const userPreferenceInitState: UserPreferenceState = {
  [UserPreferenceEnum.inbondLayout]: {
    inbondOperationsLayout: UserPreferenceConfig.userPreferenceInitialState.inbondOperationsLayout, 
    inbondAuditLayout: UserPreferenceConfig.userPreferenceInitialState.inbondAuditLayout, 
    inbondCompletedLayout: UserPreferenceConfig.userPreferenceInitialState.inbondCompletedLayout,
  },
  [UserPreferenceEnum.redeliveryLayout]: {
    redeliveryPendingLayout: UserPreferenceConfig.userPreferenceInitialState.redeliveryPendingLayout,
    redeliveryCompletedLayout: UserPreferenceConfig.userPreferenceInitialState.redeliveryCompletedLayout,
  },
};

const reducer = createReducer(
  userPreferenceInitState,
  on(UserPreferenceActions.getInbondLayoutPreference, (state, { componentName }) => {
    return {
      ...state,
      [componentName]: userPreferenceInitState[componentName],
    };
  }),
  on(
    UserPreferenceActions.getInbondLayoutPreferenceSuccess,
    UserPreferenceActions.updateInbondLayoutPreferenceSuccess,
    (state, { componentName, preferences }) => {
      return {
        ...state,
        [componentName]: preferences,
      };
    }
  ),
  on(UserPreferenceActions.getRedeliveryLayoutPreference, (state, { componentName }) => {
    return {
      ...state,
      [componentName]: userPreferenceInitState[componentName],
    };
  }),
  on(
    UserPreferenceActions.getRedeliveryLayoutPreferenceSuccess,
    UserPreferenceActions.updateRedeliveryLayoutPreferenceSuccess,
    (state, { componentName, preferences }) => {
      return {
        ...state,
        [componentName]: preferences,
      };
    }
  ),
);

export const UserPreferenceReducer = {
  reducer,
  userPreferenceFeatureKey,
  userPreferenceFeatureSelector,
  userPreferenceInitState,
};
